import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-blue-label',
  templateUrl: './blue-label.component.html',
  styleUrls: ['./blue-label.component.css']
})
export class BlueLabelComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
